import React from 'react';
import 'sanitize.css';
import { Outlet } from 'react-router-dom';
import ScrollToTop from '../ScrollToTop/ScrollToTop';
import 'core-js/stable';
import 'regenerator-runtime/runtime';
import DataProvider from '../DataContext/DataProvider';
import Loader from '../Loader';
import ErrorBoundaryWrapper from '../ErrorBoundaryWrapper'; // ✅ Updated import
import NavBar from '../NavBar';
import EmptyStyle from '../ui/EmptyStyle';
import UnsupportedBrowserMessage from '../ui/UnsupportedBrowserMessage';
import DropDownController from '../DropDownController';
import { ToastContainer } from 'react-toastify';
import SuggestionList from '../../components/SuggestionList';

const MainLayout = () => {
  return (
    <DataProvider>
      <Loader>
        <ScrollToTop>
          <NavBar />
          <SuggestionList />
          <DropDownController />
          <EmptyStyle />
          <ToastContainer />
          <UnsupportedBrowserMessage />
          <div className="scrollY" id="scrollable">
            <ErrorBoundaryWrapper>
              <Outlet />
            </ErrorBoundaryWrapper>
          </div>
        </ScrollToTop>
      </Loader>
    </DataProvider>
  );
};

export default MainLayout;
